import React, { useState, useEffect } from "react";
import Button from "components/Button";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import "./index.scss";

const Dropdown = ({
  value,
  buttonLabel,
  buttonColor,
  buttonType,
  buttonBlock,
  iconOnly,
  icon,
  data,
  className,
  ...props
}) => {
  const [listOpen, setListOpen] = useState(false);

  const isMeasuring = localStorage.getItem("isMeasuring");

  useEffect(() => {
    if (!isMeasuring && listOpen) {
      setListOpen(false);
    }
  }, [isMeasuring, listOpen]);

  useEffect(() => {
    localStorage.removeItem("isMeasuring");
  }, []);
  const handleDropdownClick = (e) => {
    if (!listOpen) {
      localStorage.setItem("isMeasuring", "1");
    } else {
      localStorage.removeItem("isMeasuring");
    }
    setListOpen(!listOpen);
    e.stopPropagation();
  };

  return (
    <div className={`measure-dropdown-wrapper ${className}`} {...props}>
      <div className={`dropdown-list ${listOpen ? "-show" : "-hidden"}`}>
        {data.map((item) => (
          <button
            id={item.id}
            className={`drop-button ${item.customClass || ""}`}
            type="button"
            key={item.id}
            onClick={item.handleClick}
            data-value={value}
          >
            {item.children}
          </button>
        ))}
      </div>
      <ReactTooltip
        id="measure-tip"
        place="right"
        effect="solid"
        clickable
        type="dark"
      >
        <div className="measure-tooltip">
          <h1 className="title">Measure Tool</h1>
          <p className="text">Set of tools to measure your fields.</p>
          <p className="text">
            This is different from creating a field boundaries.
          </p>
        </div>
      </ReactTooltip>
      <Button
        id="measure-action"
        data-tip
        data-for="measure-tip"
        customClassName={`mapboxgl-ctrl ${isMeasuring ? "-active" : ""}`}
        label={buttonLabel}
        iconOnly={iconOnly}
        color={buttonColor}
        type={buttonType}
        block={buttonBlock}
        icon={icon}
        onTouchStart={handleDropdownClick}
        onClick={handleDropdownClick}
        {...props}
      />
    </div>
  );
};

Dropdown.propTypes = {
  value: PropTypes.string,
  iconOnly: PropTypes.bool,
  buttonLabel: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonType: PropTypes.string,
  buttonBlock: PropTypes.bool,
  icon: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      handleClick: PropTypes.func.isRequired,
    })
  ).isRequired,
};

Dropdown.defaultProps = {
  value: null,
  iconOnly: false,
  buttonLabel: "",
  buttonColor: "white",
  buttonType: "solid",
  buttonBlock: false,
  icon: "",
  className: "",
};

export default Dropdown;
